import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import "../scss/contact.scss";
import InputItem from "../components/InputItem";
import HomeIcon from "@material-ui/icons/Home";
import LocationOnIcon from "@material-ui/icons/LocationOn";
import PhoneIcon from "@material-ui/icons/Phone";
import MailIcon from "@material-ui/icons/Mail";
import { validEmail, validNumber, validInput } from "../utils/formValidation";
import { sendEmail } from "../utils/email";

const InfoOption = ({ Icon, info }) => {
  return (
    <div className="info">
      {Icon}
      <p>{info}</p>
    </div>
  );
};
const Contact = () => {
  const history = useHistory();

  const [contact, setContact] = useState({
    lastName: "",
    firstName: "",
    email: "",
    tel: "",
    message: "",
  });

  const handleChange = (e) => {
    e.preventDefault(e);
    const { id, value } = e.target;
    setContact((prevState) => ({
      ...prevState,
      [id]: value,
    }));
  };

  const [contactValid, setContactValid] = useState(false);

  const [validValues, setValidValues] = useState({
    firstName: true,
    lastName: true,
    email: true,
    tel: true,
    message: true,
  });

  const validationOfValues = () => {
    const _validValues = {};

    for (const [key, value] of Object.entries(contact)) {
      if (key === "email") {
        const valid = validEmail(value);
        _validValues[key] = valid;
      } else if (key === "tel" && value !== "") {
        const valid = validNumber(value);
        _validValues[key] = valid;
      } else {
        const valid = validInput(value);
        if (key !== "tel") {
          _validValues[key] = valid;
        }
      }
    }

    setValidValues(_validValues);
    if (!Object.values(_validValues).includes(false)) {
      setContactValid(true);
    }
  };

  const sendAsk = (e) => {
    e.preventDefault();
    validationOfValues();
  };

  useEffect(() => {
    document.title = "Contacter Cartésia Junior";
    if (contactValid) {
      sendEmail("", contact);
      history.push("/");
    }
  });

  return (
    <div className="contact">
      <div className="company-info">
        <span>Nous contacter !</span>
        <div>
          <InfoOption
            info="Cartésia Junior"
            Icon={<HomeIcon className="contact-icon" />}
          />
          <div className="info">
            <LocationOnIcon className="contact-icon" />
            <p>
              <span>143 avenue de Versailles</span>
              <span>75016 Paris</span>
            </p>
          </div>
          <InfoOption
            info="0135487895"
            Icon={<PhoneIcon className="contact-icon" />}
          />
          <InfoOption
            info={<a href="mailto:contact.cartesia@gmail.com">contact.cartesia@gmail.com</a>}
            Icon={<MailIcon className="contact-icon" />}
          />
        </div>
        <div className="location">
          <iframe
            title="localisation"
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2625.8481607999724!2d2.2657726156738156!3d48.84203487928586!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x47e67aa382cbd2f1%3A0xee0152d0d9c6df43!2s143%20Avenue%20de%20Versailles%2C%2075016%20Paris!5e0!3m2!1sen!2sfr!4v1596987547243!5m2!1sen!2sfr"
            width="500"
            height="300"
            frameBorder="0"
            allowFullScreen=""
            aria-hidden="false"
            tabIndex="0"
          ></iframe>
        </div>
      </div>
      <hr className="vertical-line"></hr>
      <div className="contact-form">
        <span>Nous écrire</span>
        <p>
          Vous souhaitez nous contacter pour vous renseigner sur nous, il suffit
          de remplir vos coordonnées et on vous répondra dans les plus brefs
          délais !
        </p>
        <form>
          <InputItem
            id="lastName"
            description="Nom"
            placeHolder="Votre nom"
            value={contact.lastName}
            handleChange={handleChange}
            required="true"
            validation={validValues.lastName}
          />
          <InputItem
            id="firstName"
            description="Prenom"
            placeHolder="Votre prénom"
            value={contact.firstName}
            handleChange={handleChange}
            required="true"
            validation={validValues.firstName}
          />
          <InputItem
            id="email"
            description="Email"
            placeHolder="Votre email"
            value={contact.email}
            handleChange={handleChange}
            required="true"
            validation={validValues.email}
          />
          <InputItem
            id="tel"
            description="Téléphone"
            placeHolder="Votre numéro"
            value={contact.tel}
            handleChange={handleChange}
            validation={validValues.tel}
          />
          <InputItem
            id="message"
            description="Message"
            customStyle="text-area"
            placeHolder="Votre message"
            value={contact.message}
            handleChange={handleChange}
            item="text-area"
            required="true"
            validation={validValues.message}
          />
          <button className="contact-btn" onClick={(e) => sendAsk(e)}>
            Envoyer
          </button>
        </form>
      </div>
    </div>
  );
};

export default Contact;
